// Real pages from GOLFKLAR™ Bind 1 (Gamma Studio), WebP 1512×1890 on Higgsfield CDN (media_upload 2026-10-22).
// InsidePages only shows entries with a src. Never use images from another product here.
const IMG_BASE = 'https://d2ol7oe51mr4n9.cloudfront.net/user_37MCUZnyYhEzEhcHxirwYMezT12/';

export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [
  {
    src: `${IMG_BASE}73758f98-277a-4a4d-8752-1616b9d76399.webp`,
    label: 'Bind 1 · Forside',
    title: 'Sesongplan, periodisering og 12 ferdige gruppeøkter',
    text: 'Bind 1 samler årshjulet og tolv gruppeøkter minutt for minutt – med øktkort til utskrift, tre nivåer i hver økt og økter både ute og inne.'
  },
  {
    src: `${IMG_BASE}44479276-c737-46eb-a29d-32654a11c99b.webp`,
    label: 'Årshjul · Side 4',
    title: 'Årshjulet for golfgruppen',
    text: 'Innesesong, forsesong, hovedsesong, høst og overgang – uke for uke, med innholdet i hver periode. Juster ukene etter når range og bane åpner i din klubb.'
  },
  {
    src: `${IMG_BASE}993e4ddb-c093-4eff-8b5c-8420b082bbc4.webp`,
    label: 'Gruppeøkt · Side 14',
    title: 'Økt 2: Ballkontakt med korte jern',
    text: 'Trenerens side: oppvarming 0–10, hovedøkt med tre stasjoner 10–40, spill/konkurranse 40–52 og oppsummering 52–60 – med mål, utstyr og trenerens instruksjon.'
  },
  {
    src: `${IMG_BASE}930221ba-c83e-40be-9b19-120690e870fa.webp`,
    label: 'Øktkort · Side 23',
    title: 'Økt 6: Bunkerslag',
    text: 'Øktkort med stasjonskart for bunkeren (stasjon A, B og C og landingssone), tidsbruk per del og tre nivåer – fra ballen ut av bunkeren til hullet fra ulike leier.'
  },
  {
    src: `${IMG_BASE}bc3c3df7-beec-4c70-b22f-71ddd8b04816.webp`,
    label: 'Øktkort · Side 29',
    title: 'Økt 9: Simulator og avstandskontroll',
    text: 'Innendørsøkt med romskisse: simulatorbås, puttematte og mobilitetssone, tre nivåer med jern 7 og jern 9 – til vinteren når rangen er stengt.'
  }
];
